module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-rechts_black-4a23add8d6d3cf5dbd5761e99dd85365.svg";